import { create } from 'zustand';
import { authService } from '../services';

const useAuthStore = create((set, get) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  error: null,
  
  initialize: async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      set({ isLoading: false, isAuthenticated: false });
      return;
    }
    
    try {
      const user = await authService.getMe();
      set({ user, isAuthenticated: true, isLoading: false });
    } catch (error) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      set({ user: null, isAuthenticated: false, isLoading: false });
    }
  },
  
  login: async (email, password) => {
    set({ error: null });
    try {
      const user = await authService.login(email, password);
      set({ user, isAuthenticated: true });
      return user;
    } catch (error) {
      const message = error.response?.data?.message || 'Login failed';
      set({ error: message });
      throw error;
    }
  },
  
  register: async (data) => {
    set({ error: null });
    try {
      const response = await authService.register(data);
      // If registration requires verification, don't set as authenticated
      if (response.requiresVerification) {
        return { requiresVerification: true, user: response.user };
      }
      // If tokens are provided, user is authenticated
      if (response.user) {
        set({ user: response.user, isAuthenticated: true });
        return response;
      }
      return response;
    } catch (error) {
      const message = error.response?.data?.message || 'Registration failed';
      set({ error: message });
      throw error;
    }
  },
  
  logout: async () => {
    try {
      await authService.logout();
    } finally {
      set({ user: null, isAuthenticated: false });
    }
  },
  
  updateProfile: async (data) => {
    const user = await authService.updateProfile(data);
    set({ user });
    return user;
  },
  
  updateAvatar: async (file) => {
    const { avatar } = await authService.updateAvatar(file);
    set((state) => ({
      user: { ...state.user, avatar }
    }));
    return avatar;
  },
  
  setUser: (user) => set({ user }),
  clearError: () => set({ error: null })
}));

export default useAuthStore;
